<draggable-container [prefix]="data.prefix">
  <quill-editor (onEditorCreated)='editorInit($event)' class="w-100" [id]="data.prefix+'textBox'"
  [(ngModel)]="data.text" [modules]="modules" [sanitize]="true"></quill-editor>
</draggable-container>
